export const theme = {
  bgColor: "gray.700",
  grayColor: "gray.400",
  blueColor: "blue.400",
};
